"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CartIcon;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _reactRouterDom = require("react-router-dom");

var _fetchInvoice = _interopRequireDefault(require("./fetchInvoice"));

function getNumOrders(_ref) {
  var invoice = _ref.invoice,
      lineItems = _ref.lineItems;
  var isInvoicePending = invoice && invoice.status.toLowerCase() === 'pending';
  var numOrders = lineItems && isInvoicePending && lineItems.length;
  return numOrders;
}

function CartIcon() {
  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      invoices = _React$useState2[0],
      setInvoices = _React$useState2[1];

  _react["default"].useEffect(function () {
    var invoiceId = window.localStorage.getItem('[Cart] Invoice_Id');

    if (invoiceId) {
      (0, _fetchInvoice["default"])(invoiceId).then(setInvoices);
    }
  }, []);

  var numOrders = invoices && getNumOrders(invoices);
  return _react["default"].createElement(_reactstrap.Button, {
    color: "topcart",
    size: "sm"
  }, _react["default"].createElement(_reactRouterDom.Link, {
    to: "/cart"
  }, _react["default"].createElement("img", {
    src: "https://s3.amazonaws.com/honeyguide/assets/icons/cart.png",
    alt: ""
  }), " Cart ", numOrders ? _react["default"].createElement("div", {
    className: "indicator"
  }) : null));
}